module.exports = __webpack_public_path__ + "static/media/plantHealth.37b4568f.png";